import JustificationsPage from '../../pages/Justifications';
import { SurveillantLayout } from '../SurveillantLayout';

export default function JustificationsWrapper() {
  return (
    <SurveillantLayout title="Justifications" fullWidth>
      <JustificationsPage />
    </SurveillantLayout>
  );
}
